import translationsEN from "../i18n/locales/en";
import translationsES from "../i18n/locales/es";
import translationsPT from "../i18n/locales/pt";
import { currentOrientation } from "../redux-saga/redux/settings";
import Session from "./session";

/**
 * To check the email validation
 * @function validateEmail
 *
 * @param {string} email
 * @returns {boolean} boolean
 */
export const validateEmail = (email) => {
  const validate = String(email).match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return !!validate;
};

/**
 * To check if two passwords match
 *
 * @param {string} password
 * @param {string} confirmPassword
 * @returns {boolean} boolean
 */
export const isMatchPassword = (password, confirmPassword) =>
  password === confirmPassword;

/**
 * Ensure that the password is alphanumeric and includes 4-8 characters.
 *
 * @param {string} password
 * @returns {boolean} boolean
 */
export const validatePassword = (password) => {
  const validate = String(password).match(
    /(?=.*[a-z])(?=.*\d)[A-Za-z0-9!@#$%^&*]{5,}$/
    // /(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/
  );
  return !!validate;
};

/**
 * To check Phone Number Validation
 *
 * @param {string} string
 * @returns {boolean} boolean
 */
export const validatePhoneNumber = (string) => {
  const validate = String(string).match(
    /^\+?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4,6}$/im
  );
  return !!validate;
};

/**
 * To check string contain only numbers
 *
 * @param {string} string
 * @returns {boolean} boolean
 */
export const validateNumber = (string) => {
  const validate = String(string).match(/^[0-9]*$/);
  return !!validate;
};

/**
 * To check string contain only letters,
 * Vaidates for a-z, A-Z and white space
 *
 * @param {string} string
 * @returns {boolean} boolean
 */
export const validateLetters = (string) => {
  const validate = String(string).match(/^[a-zA-Z ]{2,30}$/);
  return !!validate;
};

/**
 * To format Category name
 *
 * @param {string} string
 * @returns Upper case First alphabet with the '-' character removed if it contains.
 */

export const formatCategoryName = (name) => {
  if (name) {
    let tempName = name.replace("-", " ");
    tempName = tempName.charAt(0).toUpperCase() + tempName.slice(1);
    return tempName;
  }
  return "";
};

/**
 * To format wallet address according to the boolean
 *
 * @param {boolean} boolean
 * @param {string} string
 * @returns Concatenation of First 5 alphabet and '...'
 */
export const formatWalletAddress = (show, walletAddress) => {
  let address;
  if (show && walletAddress) {
    return walletAddress;
  }
  if (walletAddress) {
    address = walletAddress.slice(0, 5);
    address += "...";
  }
  if (!walletAddress) {
    address = "Not Found";
  }
  return address;
};

/**
 * To check if a string is numeric or not
 *
 * @param {string} string
 * @returns {boolean} boolean
 */
export const isNumeric = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

/**
 * Get the translated value of the supplied key.
 *
 * @param {string} string
 * @returns {string} Translated string
 */
export const getTranslation = (key) => {
  if (!key) {
    return "";
  }
  const language = Session.getLanguage;
  const translationKey = key.split(".");
  if (translationKey.length !== 2) {
    return "";
  }
  let translation = "";
  if (language === "en") {
    translation = translationsEN?.[translationKey[0]]?.[translationKey[1]];
  }
  if (language === "es") {
    translation = translationsES?.[translationKey[0]]?.[translationKey[1]];
  }
  if (language === "pt") {
    translation = translationsPT?.[translationKey[0]]?.[translationKey[1]];
  }
  return translation || "";
};

export function orinetationhandler(dispatch) {
  var mediaQueryRule = window.matchMedia("(orientation: portrait)");
  mediaQueryRule.onchange = function () {
    if (window.matchMedia("(orientation: portrait)").matches) {
      dispatch(currentOrientation("PORTRAIT"));
    }
    if (window.matchMedia("(orientation: landscape)").matches) {
      dispatch(currentOrientation("LANDSCAPE"));
    }
  };
}

export function processImageURL(imageUrl) {
  if (!imageUrl) {
    return null;
  }
  const regex = /https?:\/\/[^/]+\/(.+)/;
  const match = imageUrl.match(regex);
  if (match) {
    const extractUrl = match[1];
    return process.env.REACT_APP_CDN_IMAGE_URL + extractUrl;
  } else {
    return process.env.REACT_APP_CDN_IMAGE_URL + imageUrl;
  }
}
